import * as React from 'react';
import { composer } from '../../../component-decorators/composer';
import { Card } from 'wix-style-react';
export var BusinessHeader = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t;
    return (React.createElement(Card.Header, { dataHook: 'installed-business-apps-title', title: t('manage-apps.business-apps.card-header.title') }));
});
//# sourceMappingURL=business.apps-section-header.js.map